import { render } from "./ItemKeywordSearch.vue?vue&type=template&id=1bf1e9d7&scoped=true&ts=true"
import script from "./ItemKeywordSearch.vue?vue&type=script&lang=ts"
export * from "./ItemKeywordSearch.vue?vue&type=script&lang=ts"

import "./ItemKeywordSearch.vue?vue&type=style&index=0&id=1bf1e9d7&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf1e9d7"]])

export default __exports__